<template>
  <header id="header">
    <h1>Numnator</h1>
  </header>
</template>

<script>
export default {
  name: 'HeaderItem'
};
</script>

<style scoped>
header {
  background-color: #0d3f67;
  color: #f2f4f6;
}
h1 {
  margin: 0 0 10px 0;
}
</style>